<form [formGroup]="registerForm" autocomplete="off" class="form-container">

  <div class="row w-100 m-0 p-0">
    <mat-form-field appearance="outline" class="col-lg-4">
      <mat-label>Tipo de presentación</mat-label>
      <mat-select formControlName="registerType" required style="font-size:16px;">
        <mat-option [value]="null">Seleccionar</mat-option>
        <mat-option *ngFor="let item of registerType" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="registerForm.get('registerType').hasError('required')">
        El Tipo de presentación es <strong>requerido</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-4">
      <mat-label>DNI, RUC o Carnet de extranjería</mat-label>
      <input matInput formControlName="document" maxlength="12" required placeholder="Ingresar documento"
        oninput="this.value=this.value.trim()==''?'':this.value" (keypress)="keypressNumber($event)">
      <mat-error *ngIf="registerForm.get('document').hasError('required')">
        El documento es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('document').hasError('minlength')">
        El documento es <strong>inválido</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-4">
      <mat-label>Nombres</mat-label>
      <input matInput formControlName="name" maxlength="100" required placeholder="Ingresar tus nombres"
        oninput="this.value=this.value.trim()==''?'':this.value" (keypress)="keypress($event)">
      <mat-error *ngIf="registerForm.get('name').hasError('required')">
        El nombre es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('name').hasError('minlength')">
        El nombre mínimo debe tener <strong>1 carácter</strong>.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row w-100 m-0 p-0">
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label>Apellido paterno</mat-label>
      <input matInput formControlName="lastname" maxlength="100" required placeholder="Ingresar apellido paterno"
        oninput="this.value=this.value.trim()==''?'':this.value" (keypress)="keypress($event)">
      <mat-error *ngIf="registerForm.get('lastname').hasError('required')">
        El apellido paterno es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('lastname').hasError('minlength')">
        El apellido paterno mínimo debe tener <strong>1 carácter</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label>Apellido materno</mat-label>
      <input matInput formControlName="secondname" maxlength="100" placeholder="Ingresar apellido materno"
        oninput="this.value=this.value.trim()==''?'':this.value" (keypress)="keypress($event)">
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label>Correo electrónico</mat-label>
      <input matInput formControlName="email" maxlength="100" required placeholder="Ingresar correo electrónico"
        oninput="this.value=this.value.trim()==''?'':this.value">
      <mat-error *ngIf="registerForm.get('email').hasError('required')">
        El correo electrónico es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('email').hasError('minlength')">
        El correo electrónico mínimo debe tener <strong>1 carácter</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('email').hasError('pattern') || registerForm.get('email').hasError('email')">
        El correo electrónico tiene <strong>formato incorrecto</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label>Número de celular</mat-label>
      <input matInput formControlName="phone" maxlength="9" required placeholder="Ingresar Número de celular"
        oninput="this.value=this.value.trim()==''?'':this.value" (keypress)="keypressNumber($event)" #numerocelular>
      <mat-hint align="end">{{numerocelular.value.length}} / 9</mat-hint>
      <mat-error *ngIf="registerForm.get('phone').hasError('required')">
        El número de celular es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('phone').hasError('minlength')">
        El número de celular debe tener <strong>9 carácteres</strong>.
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row w-100 m-0 p-0">
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label>Departamento</mat-label>
      <mat-select formControlName="depart" (selectionChange)="getListProv(registerForm.get('depart').value)" required
        style="font-size:16px;">
        <mat-option [value]="null" *ngIf="!registerForm.get('depart').value">Seleccionar</mat-option>
        <mat-option *ngFor="let item of dep" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="registerForm.get('depart').hasError('required')">
        El departamento es <strong>requerido</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label *ngIf="!loadingProvin">Provincia</mat-label>
      <mat-label *ngIf="loadingProvin">Cargando</mat-label>
      <mat-select formControlName="provin" (selectionChange)="getListDistritc(registerForm.get('provin').value)"
        required [disabled]="loadProvin" style="font-size:16px;">
        <mat-option [value]="null" *ngIf="!registerForm.get('provin').value">Seleccionar</mat-option>
        <mat-option *ngFor="let item of pro" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="registerForm.get('provin').hasError('required')">
        El provincia es <strong>requerido</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label *ngIf="!loadingdDis">Distrito</mat-label>
      <mat-label *ngIf="loadingdDis">Cargando</mat-label>
      <mat-select formControlName="district" required [disabled]="loadDis" style="font-size:16px;">
        <mat-option [value]="null" *ngIf="!registerForm.get('district').value">Seleccionar</mat-option>
        <mat-option *ngFor="let item of dis" [value]="item.id">
          {{item.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="registerForm.get('district').hasError('required')">
        El distrito es <strong>requerido</strong>.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-lg-3">
      <mat-label>Dirección</mat-label>
      <input matInput formControlName="direction" maxlength="255" required placeholder="Ingresar Dirección"
        oninput="this.value=this.value.trim()==''?'':this.value" #direccion>
      <mat-hint align="end">{{direccion.value.length}} / 255</mat-hint>
      <mat-error *ngIf="registerForm.get('direction').hasError('required')">
        El dirección es <strong>requerido</strong>.
      </mat-error>
      <mat-error *ngIf="registerForm.get('direction').hasError('minlength')">
        El dirección debe tener <strong>8 carácteres</strong>.
      </mat-error>
    </mat-form-field>
  </div>

</form>
<!-- 
[disabled]="registerForm.invalid || invalidForm "
(click)="send()" 
-->